import { Observable } from "rxjs";
import { MacroGoals } from "./patients";

export abstract class MacroGoalsData {
  abstract getAutoMacroGoals(patientId: number): Observable<MacroGoals>;
}